import _ from 'lodash'
import { ICoordinate, IPageData, IPageParams } from "../types"
import { ICommonStatusData } from "./screen.types"
import { E_AlarmLevel, E_AlarmType } from '../enums'

/**
 * 报警等级
 * $t('enum.E_AlarmLevelString.A')
 * $t('enum.E_AlarmLevelString.B')
 * $t('enum.E_AlarmLevelString.C')
 * $t('enum.E_AlarmLevelString.D')
 */
export enum E_AlarmLevelString {
    A = '0',
    B = '1',
    C = '2',
    D = '3',
}

export const E_AlarmLevelString__Inverse = _.invert(E_AlarmLevelString)


export interface ILargeScreenAddAreaFileParams {
    fileId: number
    id: number
}

export interface ILargeScreenAddCompanyFileParams {
    fileId: number
    id: number
}

export interface ILargeScreenGetAlarmListParams {
    areaId: number
    companyId: number
}

export interface ILargeScreenGetAlarmListItem {
    alarmLevel: E_AlarmLevelString
    createTime: string
    equipmentName: string
}

export type ILargeScreenGetAlarmListData = ILargeScreenGetAlarmListItem[]

export interface ILargeScreenGetAreaFileParams {
    /**
     * 区域id
     */
    areaId: number
}

export type ILargeScreenGetAreaFileData = string


export interface ILargeScreenGetCompanyCoordinatesParams {
    companyId: number
}

/**
 * 公司区域坐标详情
 */
export interface IAreaCoordinatesListItem extends ICoordinate {
    /**
     * 区域id
     */
    areaId: number
}

export interface ILargeScreenGetCompanyCoordinatesData {
    /**
     * 区域坐标
     */
    areaCoordinatesList: IAreaCoordinatesListItem[]
    fileUrl: string
    id: number
}

export interface ILargeScreenGetCompanyScreenParams {
    companyId: number
}

/**
 * 区域大屏返回
 */
export interface IAreaScreenListItem extends ICoordinate {
    /**
     * 区域id
     */
    areaId: number
    /**
     * 区域名称
     */
    areaName: string
    /**
     * 设备数量
     */
    equipmentNum: number
    /**
     * 传感器数量
     */
    sensorNum: number
}

export interface ILargeScreenGetCompanyScreenData {
    /**
     * 区域信息
     */
    areaScreenList: IAreaScreenListItem[]
    fileUrl: string
    id: number
}

export interface ILargeScreenGetCompanyStatisticsParams {
    areaId: number
    companyId: number
}


export interface ILargeScreenGetCompanyStatisticsData {
    areaId: number
    companyId: number
    /**
     * 故障诊断数量
     */
    diagnosisNum: number
    /**
     * 设备数量
     */
    equipmentNum: number
    /**
     * 传感器数量
     */
    sensorNum: number
}

export interface ILargeScreenGetSensorStatisticsParams {
    areaId: number
    companyId: number
}

export interface ILargeScreenGetSensorStatisticsData {
    /**
     * 
     */
    calarmNum: number
    /**
     * 
     */
    dalarmNum: number
    /**
     * 
     */
    normalNum: number
    /**
     * 
     */
    offlineNum: number
}

export interface ILargeScreenSetCoordinatesParams extends ICoordinate {
    /**
     * 
     */
    areaId: number
}


export interface ILargeScreenGetOrdinaryCompanyStatisticsParams {
    companyId: number
    areaId: number
}

export interface ILargeScreenGetOrdinaryCompanyStatisticsData {
    /**
     * 区域数量
     */
    areaNum: number
    /**
     * 故障诊断数量
     */
    diagnosisNum: number
    /**
     * 设备数量
     */
    equipmentNum: number
    /**
     * 传感器数量
     */
    sensorNum: number
}
export interface ILargeScreenGetAlarmStatisticsParams {
    areaId: number
    companyId: number
}

export interface ILargeScreenGetAlarmStatisticsItem {
    alarmNum: number
    date: string
}

export type ILargeScreenGetAlarmStatisticsParamsData =
    ILargeScreenGetAlarmStatisticsItem[]


export interface ILargeScreenAddParentCompanyFileParams {
    fileId: number
    id: number
}


//#region 总公司

export interface IProvinceCompanyParams {
    companyId?: number
    provinceName?: string
}

export interface ILargeScreenGetAlarmRankingItem {
    companyName: string
    num: string
}

export type ILargeScreenGetAlarmRankingParams = IProvinceCompanyParams

export type ILargeScreenGetAlarmRankingData = ILargeScreenGetAlarmRankingItem[]

export type ILargeScreenGetEquipmentAlarmStatistics = IProvinceCompanyParams

export interface ILargeScreenGetEquipmentAlarmStatisticsData {
    calarmCount: number
    dalarmCount: number
    onlineCount: number
}

export interface IProvinceListItem {
    cityList: any[]
    /**
     * 公司数量
     */
    companyNum: number
    /**
     * 设备数量
     */
    equipmentNum: number
    /**
     * 省/市
     */
    name: string
    /**
     * 传感器数量
     */
    sensorNum: number
}

export type ILargeScreenGetLargeScreenStatistics = IProvinceCompanyParams

export interface ICountrySummary {
    /**
     * 城市数量
     */
    cityNum: number
    /**
     * 故障诊断数量
     */
    diagnosisNum: number
    /**
     * 设备数量
     */
    equipmentNum: number
    /**
     * 传感器数量
     */
    sensorNum: number
}

export interface ILargeScreenGetLargeScreenStatisticsData extends ICountrySummary {
    /**
     * 省统计
     */
    provinceList: IProvinceListItem[]
}

export type ILargeScreenGetMachineStatisticsParams = IProvinceCompanyParams

export interface ILargeScreenGetMachineStatisticsData {
    areaId: number
    companyId: number
    /**
     * 故障诊断数量
     */
    diagnosisNum: number
    /**
     * 设备数量
     */
    equipmentNum: number
    /**
     * 传感器数量
     */
    sensorNum: number
}

export interface ISensorScreenDTO {
    battery
    createTime
    equipmentId
    mappingId
    mappingName
    sensorId
    tem
    vx
    vy
    vz
}

export interface IMachineListItem {
    equipmentId: number
    equipmentName: string
    sensorItem: ICommonStatusData[]
    sensorList: ISensorScreenDTO[]
}

export interface ILargeScreenGetMachineStatisticsData {
    equipment: ICommonStatusData
    machineList: IMachineListItem[]
    sensor: ICommonStatusData
}

export interface ILargeScreenGetSensorRankingItem {
    companyName: string
    num: number
}

export type ILargeScreenGetSensorRankingParams = IProvinceCompanyParams

export type ILargeScreenGetSensorRankingData = ILargeScreenGetSensorRankingItem[]


export interface ILargeScreenGetCompanyListByProvinceParams {
    provinceName: string
}

export interface ILargeScreenCompanyItem {
    address?: string
    city?
    code?
    fileId?
    fileUrl?
    id: number
    name: string
    parentId?
    province?
    remark?
    status?
    userName?
}

export type ILargeScreenGetCompanyListByProvinceData =
    ILargeScreenCompanyItem[]

export interface ILargeScreenAlaramHistoryParams {
    companyId: number
}

export interface ILargeScreenGetMappingAlarmStatisticsRecordParams {
    companyId: number
}

export interface IMappingAlarmStatisticsItem {
    /**
     * C级报警数量
     */
    alarmLevelc: number
    /**
     * D级报警数量
     */
    alarmLeveld: number
    /**
     * 时间
     */
    dayTime: string
}

export type ILargeScreenGetMappingAlarmStatisticsRecordData =
    IMappingAlarmStatisticsItem[]

//#endregion


export interface ILargeScreenV2AlarmTrendParams {
    companyId?: number
    areaId?: number
}

export interface ILargeScreenV2AlarmTrendItem {
    calarmNum: number
    dalarmNum: number
    /**
     * 报警时间
     */
    dayDate: string
}

export type ILargeScreenV2AlarmTrendData = ILargeScreenV2AlarmTrendItem[]

export interface ILargeScreenV2CurrentStatusSensorParams {
    companyId?: number
    areaId?: number
}

export interface ILargeScreenV2CurrentStatusSensorData {
    /**
     * 传感器正常数量
     */
    sensorNormalNum: number
    /**
     * 传感器报警数量
     */
    sensorAlarmNum: number
    /**
     * 传感器离线数量
     */
    sensorOfflineNum: number
    /**
     * 传感器总数量
     */
    sensorTotalNum: number
}

export interface ILargeScreenV2FaultDiagnosisStatisticsParams {
    companyId?: number
    areaId?: number
}

export interface IFaultDiagnosisListItem {
    areaId: number
    companyId: number
    equipmentId: number
    equipmentName: string
    /**
     * 故障编号
     */
    faultSn: string
    faultTypeIds: string[]
    suggestTypeIds: string[]
    /**
     * 诊断时间
     */
    faultTime: string
}

export interface IFaultDiagnosisNumListItem {
    /**
     * AI诊断条数
     */
    aiDiagnosisNum: number
    /**
     * 时间
     */
    dayDate: string
    /**
     * 模型诊断条数
     */
    modelDiagnosisNum: number
}

export interface ILargeScreenV2FaultDiagnosisStatisticsData {
    /**
     * 故障诊断记录
     */
    faultDiagnosisList: IFaultDiagnosisListItem[]
    /**
     * 历史故障诊断条数统计
     */
    faultDiagnosisNumList: IFaultDiagnosisNumListItem[]
    /**
     * 月AI诊断条数
     */
    monthAiDiagnosisNum: number
    /**
     * 月模型诊断条数
     */
    monthModelDiagnosisNum: number
    /**
     * AI诊断条数
     */
    todayAiDiagnosisNum: number
    /**
     * 模型诊断条数
     */
    todayModelDiagnosisNum: number
}

export interface ILargeScreenV2EquipmentRunStatisticsParams {
    companyId?: number
    areaId?: number
}

export interface IDayRunListItem {
    dayDate: string
    /**
     * 开机设备数量
     */
    equipmentStartUpNum: number
    /**
     * 设备数量
     */
    equipmentTotalNum: number
}

export interface ILargeScreenV2EquipmentRunStatisticsData {
    /**
     * 近7日，每日设备运行数量
     */
    dayRunList: IDayRunListItem[]
    /**
     * 设备数量
     */
    equipmentNum: number
    /**
     * 开机设备数量
     */
    equipmentRunNum: number
    /**
     * 传感器数量
     */
    sensorNum: number
}

export interface IEquipmentNums {
    /**
         * 0-59分
         */
    equipmentNum1: number
    /**
     * 60-79分
     */
    equipmentNum2: number
    /**
     * 80-100分
     */
    equipmentNum3: number
}

export interface IEquipmentScoreStatisticsVOListItem extends IEquipmentNums {
    dayDate: string
}

export interface ILargeScreenV2HealthScoreStatisticsParams {
    companyId: number
    areaId?: number
}

export interface ILargeScreenV2HealthScoreStatisticsData extends IEquipmentNums {
    equipmentScoreStatisticsVOList: IEquipmentScoreStatisticsVOListItem[]
}

export interface ILargeScreenV2TodayAlarmStatisticsParams {
    companyId: number
    areaId?: number
}

export interface ILargeScreenV2TodayAlarmStatisticsData {
    calarmNum: number
    dalarmNum: number
    totalAlarmNum: number
    undisposedNum: number
}

export interface ILargeScreenV2TodayStatusNumSensorParams {
    companyId: number
    areaId?: number
}


export interface ILargeScreenV2TodayStatusNumSensorData {
    /**
     * 
     */
    calarmSensorNum: number
    /**
     * 
     */
    dalarmSensorNum: number
    /**
     * 低电量传感器数量
     */
    lowBatterySensorNum: number
    /**
     * 传感器正常数量
     */
    sensorNormalNum: number
    /**
     * 传感器离线数量
     */
    sensorOfflineNum: number
}

export type ILargeScreenV2UndisposedAlarmListParams = IPageParams & {
    companyId?: number
    areaId?: number
}

export interface ILargeScreenV2UndisposedAlarmListItem {
    alarmLevel: E_AlarmLevel
    alarmType: E_AlarmType
    areaId
    areaName
    companyId
    companyName
    createTime
    equipmentId
    equipmentName
    sensorId
    mappingId
}

export type ILargeScreenV2UndisposedAlarmListData =
    IPageData<ILargeScreenV2UndisposedAlarmListItem>


export interface ILargeScreenV2QueryCompanyAreaParams {
    companyId: number
    areaId: number
}

export interface IAreaEquipmentListItem extends ICoordinate {
    equipmentId: number
    equipmentName: string
    sensorNum: number
    mappingAlarmNum: number
    mappingNum: number
}

export interface ILargeScreenV2QueryCompanyAreaData extends ICoordinate {
    areaId: number
    areaEquipmentList: IAreaEquipmentListItem[]
    areaName: string
    equipmentAlarmNum: number
    equipmentNum: number
    fileUrl: string
    sensorNum: number
}

export interface ILargeScreenV2QueryCompanyParams {
    companyId: number
}

export interface ILargeScreenAreaVOItem extends ICoordinate {
    areaEquipmentList
    areaId: number
    areaName: string
    equipmentAlarmNum: number
    equipmentNum: number
    fileUrl: string
    sensorNum: number
}

export interface ILargeScreenV2QueryCompanyData extends ICoordinate {
    companyId: number
    equipmentAlarmNum: number
    equipmentNormalNum: number
    equipmentOfflineNum: number
    fileUrl: string
    largeScreenAreaVOList: ILargeScreenAreaVOItem[]
}

//// 平台-新版大屏V2

export interface ILargeScreenV2PlatformOverviewData {
    equipmentTotalNum: number
    equipmentRunNum: number
    equipmentRunRate: number
    sensorTotalNum: number
    provinceNum: number
    todayAlarmNum: number
    todayModelDiagnosisNum: number
    todayAiDiagnosisNum: number
}

export interface ILargeScreenV2PlatformSensorStatus {
    totalNum: number
    normalNum: number
    displacementNum: number
    lowVoltageNum: number
    offlineNum: number
}

export interface ILargeScreenV2PlatformMapCompanyItem {
    parentCompanyId: number
    companyName: string
    province: string
    city: string
    equipmentNum: number
    sensorNum: number
    normalNum: number
    displacementNum: number
    lowVoltageNum: number
    offlineNum: number
}

export interface ILargeScreenV2PlatformMapDistributionData {
    sensorStatus: ILargeScreenV2PlatformSensorStatus
    companyList: ILargeScreenV2PlatformMapCompanyItem[]
}

export interface ILargeScreenV2PlatformSensorTypeDistributionItem {
    sensorType: string
    sensorNum: number
    rate: number
}
export type ILargeScreenV2PlatformSensorTypeDistributionData =
    ILargeScreenV2PlatformSensorTypeDistributionItem[]

export interface ILargeScreenV2PlatformEquipmentStatusData {
    totalNum: number
    normalNum: number
    normalRate: number
    alarmNum: number
    alarmRate: number
    unmonitoredNum: number
    unmonitoredRate: number
}

export interface ILargeScreenV2PlatformTodayAlarmData {
    totalNum: number
    warningNum: number
    warningRate: number
    dangerNum: number
    dangerRate: number
}

export interface ILargeScreenV2PlatformDiagnosisTrendParams {
    days?: number
}

export interface ILargeScreenV2PlatformDiagnosisTrendItem {
    dayDate: string
    aiDiagnosisNum: number
    modelDiagnosisNum: number
}
export type ILargeScreenV2PlatformDiagnosisTrendData =
    ILargeScreenV2PlatformDiagnosisTrendItem[]

export interface ILargeScreenV2PlatformAlarmTop10Item {
    rank: number
    alarmType: E_AlarmType
    alarmTypeName: string
    equipmentId: number
    equipmentName: string
    companyName: string
    parentCompanyId: number
    alarmNum: number
}
export type ILargeScreenV2PlatformAlarmTop10Data =
    ILargeScreenV2PlatformAlarmTop10Item[]

export interface ILargeScreenV2PlatformIndustryDistributionItem {
    industryType: string
    companyNum: number
    rate: number
}
export type ILargeScreenV2PlatformIndustryDistributionData =
    ILargeScreenV2PlatformIndustryDistributionItem[]


//// 总公司-新版大屏V2


export interface ILargeScreenV2ParentAlarmTrendParams { }
export interface ILlargeScreenV2ParentAlarmTrendData {
    /**
     * 危险
     */
    alarmNum: number
    /**
     * 预警
     */
    preAlarmNum: number
}


export interface ILargeScreenV2ParentFaultDiagnosisStatisticsParams { }


export interface ILargeScreenStatisticsDTO {
    companyId: number
    companyName: string
    totalNum: number
}

export interface ILargeScreenV2ParentFaultDiagnosisStatisticsData {
    /**
     * AI诊断分布
     */
    diagnosisAiList: ILargeScreenStatisticsDTO[]
    /**
     * 模型诊断分布
     */
    diagnosisUmlList: ILargeScreenStatisticsDTO[]
}

export interface ILargeScreenV2ParentFaultDiagnosisTrendParams { }

export interface ILargeScreenFaultDiagnosisItemDTO {
    /**
     * AI诊断条数
     */
    aiDiagnosisNum: number
    /**
     * 时间
     */
    dayDate: string
    /**
     * 模型诊断条数
     */
    modelDiagnosisNum: number
}

export type ILargeScreenV2ParentFaultDiagnosisTrendData = ILargeScreenFaultDiagnosisItemDTO[]



export interface ILargeScreenV2ParentParentMapListItem {
    city: string
    companyId: number
    companyName: string
    fileId: number
    fileUrl: string
    /**
     * 设备-未监测数量
     */
    nonMonitNum: number
    province: string
    /**
     * 设备-开机数
     */
    runNum: number
    /**
     * 设备-总数
     */
    totalNum: number
    /**
     * 设备-报警数
     */
    alarmNum: number
}

export type ILargeScreenV2ParentParentMapListData = ILargeScreenV2ParentParentMapListItem[]



export interface ILargeScreenV2ParentGetSensorStatisticsListParams { }
export type ILargeScreenV2ParentGetSensorStatisticsListData = ILargeScreenStatisticsDTO[]

export interface ILargeScreenV2ParentHealthScoreStatisticsParams { }

export interface IEquipmentScroeStatisticsDTO extends IEquipmentNums {
    companyId: number
    companyName: string
}

export type ILargeScreenV2ParentHealthScoreStatisticsData = IEquipmentScroeStatisticsDTO[]

export interface ILargeScreenV2ParentCompanyMapStatisticsData {
    /**
     * 设备在线数量
     */
    runNum: number
    /**
     * 传感器在线数量
     */
    sensorRunNum: number
    /**
     * 传感器总数量
     */
    sensorTotalNum: number
    /**
     * 设备总数量
     */
    totalNum: number
}

export interface IEquipmentRunStatisticsItem {
    companyId: number
    companyName: string
    runNum: number
    totalNum: number
}

export interface ILargeScreenV2ParentQueryEquipmentRunStatisticsParams { }
export type ILargeScreenV2ParentQueryEquipmentRunStatisticsData = IEquipmentRunStatisticsItem[]

export interface ILargeScreenV2ParentTodayAlarmStatisticsParams { }
export type ILargeScreenV2ParentTodayAlarmStatisticsData = ILargeScreenStatisticsDTO[]
